<!-- 历史明细 -->
<template>
  <div class="index-info" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <p class="title">
      <span>历史明细</span>
      <span class="jian_box" v-if="RiseFallMap.length" @click="hderShow">
        <van-icon name="arrow-down" v-if="!headerDown" />
        <van-icon name="arrow-up" v-else />
      </span>
    </p>

    <div class="lsmx-day" ref="lsmxDay">
      <van-sticky :offset-top="tabsHeight + headerHeight - 2" z-index="98">
        <ul class="tab">
          <li
            v-for="(item, index) in periodArr"
            :key="index"
            :class="index === checkedIndex ? 'checkedClass' : ''"
            @click="handleClick(index)"
          >
            {{ item }}天
          </li>
        </ul>
      </van-sticky>
    </div>

    <div class="pie" v-show="headerDown && RiseFallMap.length">
      <div class="left" id="pieData"></div>

      <ul class="right">
        <li v-for="(item, index) in pieExplain" :key="index">
          <p><i class="dot" :style="{ background: colorList[index] }"></i>{{ item.name }}</p>
          <p>
            {{ toFixedNum(RiseFallMap[index] * 100, 2, '%') }}
          </p>
        </li>
      </ul>
    </div>

    <div class="lsmx">
      <div class="fc-title-sticky">
        <van-sticky :offset-top="tabsHeight + headerHeight + lsmxDayHeight - 2" z-index="97">
          <ul class="title">
            <li v-if="$route.query.yzType">
              {{ $route.query.yzType == 'ETF' ? 'ETF名称' : '股票名称' }}
            </li>

            <li v-if="Obj.type_info">
              {{ Obj.type_info == 2 ? 'ETF名称' : '股票名称' }}
            </li>

            <li>起点/结束时间</li>
            <li>起/止价</li>
            <li>区间涨跌幅</li>
          </ul>
        </van-sticky>
      </div>

      <ul
        class="content-list"
        v-for="(item, index) in hList"
        :key="index"
        @click="gogufs(item.StockCode)"
      >
        <li>
          <p class="StockName">{{ item.StockName }}</p>
          <p class="StockCode">{{ removePrefix(item.StockCode) }}</p>
        </li>

        <li>
          <p>{{ dateFormat('YYYY-MM-DD', item.StartDate) }}</p>
          <p>{{ dateFormat('YYYY-MM-DD', item.EndDate) }}</p>
        </li>

        <li>
          <p>{{ toFixedNum(item.BuyPrice, 2, '') }}</p>
          <p>{{ toFixedNum(item.SellPrice, 2, '') }}</p>
        </li>

        <li :class="[judgeColor(item.SectionRate)]">
          {{ toFixedNum(item.SectionRate * 100, 2, '%') }}
        </li>
      </ul>
    </div>

    <van-button
      type="info"
      :loading="loading"
      loading-text="加载中..."
      class="all"
      @click="loadMore"
      :disabled="disabled"
      >{{ loadingText }}</van-button
    >
  </div>
</template>

<script>
import { getDyzHistory } from '@/api/details.js';
import {
  judgeColor,
  toFixedNum,
  formatStrTime,
  fangDouFun,
  dateFormat,
  getPreviousDay,
  getPreviousYear
} from '@/utils/format';
import mixin from '@/mixins/index.js';
export default {
  name: 'Home',
  mixins: [mixin],
  props: ['Obj', 'headerHeight', 'tabsHeight'],
  data() {
    return {
      checkedIndex: 0,
      pieExplain: [
        {
          name: '大于7.5%'
        },
        {
          name: '3.5%到7.5%'
        },
        {
          name: '0到3.5%'
        },
        {
          name: '-3.5%到0%'
        },
        {
          name: '-3.5%到-7.5%'
        },
        {
          name: '小于-7.5%'
        }
      ],
      colorList: [
        'rgba(255, 99, 99, 1)',
        'rgba(255, 99, 99, 0.6)',
        'rgba(255, 99, 99, 0.4)',
        'rgba(47, 200, 123, 0.4)',
        'rgba(47, 200, 123, 0.6)',
        'rgba(47, 200, 123, 1)'
      ],
      RiseFallMap: [],
      myChart: null,
      hList: [],
      start: 1,
      loading: false,
      disabled: false,
      loadingText: '查看更多',
      periodArr: [],
      lsmxDayHeight: 0,
      headerDown: true
    };
  },
  filters: {},
  created() {},
  watch: {},
  async mounted() {
    this.periodArr = this.Obj.holdPeriodList.split(',');
    this.RiseFallMap = JSON.parse(this.Obj.apiData.BacktestAnalysisResult[0].RiseFallMap);
    this.$nextTick(() => {
      this.chartFn();
    });

    var indices = this.getMaxIndices(
      this.Obj.apiData.BacktestAnalysisResult,
      'AvgSectionRate',
      'RiseProbability'
    );

    this.checkedIndex = indices.maxAvgSectionRateIndex;

    await this.getDyzHistoryFun();

    //获取历史明细天的高度
    var contentlsmxDay = this.$refs['lsmxDay'];
    this.lsmxDayHeight = contentlsmxDay.offsetHeight;
  },
  methods: {
    judgeColor,
    toFixedNum,
    formatStrTime,
    dateFormat,
    //获取最大值AvgSectionRate(平均区间涨幅)和RiseProbability(上涨概率)最大值的索引用来高亮
    getMaxIndices: function (data, avgSectionRateKey, riseProbabilityKey) {
      let maxAvgSectionRateIndex = 0;
      let maxRiseProbabilityIndex = 0;
      let maxAvgSectionRate = data[0][avgSectionRateKey];
      let maxRiseProbability = data[0][riseProbabilityKey];

      for (let i = 1; i < data.length; i++) {
        if (data[i][avgSectionRateKey] > maxAvgSectionRate) {
          maxAvgSectionRate = data[i][avgSectionRateKey];
          maxAvgSectionRateIndex = i;
        }

        if (data[i][riseProbabilityKey] > maxRiseProbability) {
          maxRiseProbability = data[i][riseProbabilityKey];
          maxRiseProbabilityIndex = i;
        }
      }

      return {
        maxAvgSectionRateIndex,
        maxRiseProbabilityIndex
      };
    },
    handleClick: fangDouFun(function (...args) {
      this.handleTab(...args);
    }, 300),
    handleTab: function (index) {
      if (this.checkedIndex === index) return false;
      this.checkedIndex = index;
      this.RiseFallMap = JSON.parse(this.Obj.apiData.BacktestAnalysisResult[index].RiseFallMap);
      this.chartFn();
      this.start = 1;
      this.getDyzHistoryFun(1);
    },
    chartFn: function () {
      var that = this;
      var chartDom = document.getElementById('pieData');
      if (that.myChart === null) {
        that.myChart = that.$echarts.init(chartDom);
      }

      var data = [];
      var arr = that.RiseFallMap.map((i, index) => {
        return (data[index] = {
          value: i * 100,
          name: ''
        });
      });

      var option = {
        series: [
          {
            type: 'pie',
            radius: '80%',
            color: that.colorList,
            data: data,
            emphasis: {
              scale: false // 禁止点击放大效果
            },
            label: {
              show: false // 隐藏坐标值
            }
          }
        ]
      };
      option && that.myChart.setOption(option);

      window.addEventListener('resize', function () {
        that.myChart.resize(); //自适应
      });
    },

    //根据传入的日期(例如 '20230619'、'2023-06-19'、'2023/06/19' 或时间戳)往前推N天是哪一天,以纯数字形式传入的日期被解释为时间戳，而不是直接作为年、月、日的组合
    getPreviousDate: function (date, days) {
      const year = date.slice(0, 4);
      const month = date.slice(4, 6);
      const day = date.slice(6, 8);

      const previousDate = new Date(`${year}-${month}-${day}`);
      previousDate.setDate(previousDate.getDate() - days);

      const previousYear = previousDate.getFullYear();
      const previousMonth = (previousDate.getMonth() + 1).toString().padStart(2, '0');
      const previousDay = previousDate.getDate().toString().padStart(2, '0');

      return `${previousYear}${previousMonth}${previousDay}`;
    },
    // 查询历史明细
    getDyzHistoryFun: function (type) {
      this.loading = true;
      this.disabled = true;
      var params = {
        userID: this.Obj.apiData.condition?.author || this.Obj.apiData.uname, //string 用户账号(详情中的)
        hashID: this.Obj.apiData.HashID, //string回测ID (云平台)
        startDate: this.Obj.startDate || dateFormat('YYYMMDD', new Date(getPreviousYear())), //string开始时间
        endDate: this.Obj.endDate || dateFormat('YYYMMDD', new Date(getPreviousDay())), //string结束时间
        holdPeriod: this.periodArr[this.checkedIndex], //int回测周期 (单选项)
        start: this.start, //Int分页开始
        count: 20 //Int分页条数
      };
      getDyzHistory(params)
        .then((res) => {
          if (res.data && res.data.length >= 20) {
            this.disabled = false;
            this.loadingText = '查看更多';
          } else {
            this.disabled = true;
            this.loadingText = '已加载全部';
          }
          if (type) {
            this.hList = res.data;
          } else {
            this.hList.push(...res.data);
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    //点击加载更多
    loadMore: function () {
      this.start += 20;
      this.getDyzHistoryFun(null);
    },
    hderShow: function () {
      this.headerDown = !this.headerDown;
    }
  }
};
</script>
<style lang="less" scoped>
.index-info {
  padding: 15px;
  .title {
    color: rgba(55, 58, 77, 0.9);
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .lsmx-day {
    ::v-deep {
      .van-sticky--fixed {
        left: 15px;
        right: 15px;
      }
    }
  }
  .tab {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 4px 0;
    overflow-x: auto;
    li {
      height: 25px;
      left: 0px;
      top: 0px;
      background: #fff;
      border: 0.5px solid #f5f6f9;
      border-radius: 4px;
      padding: 0 14px;
      font-weight: 400;
      font-size: 12px;
      line-height: 25px;
      color: #555;
      margin-right: 9px;
      margin: 4px 4px 4px 0;
      flex-shrink: 0;
    }
    .checkedClass {
      background: #eaf1ff;
      border: 1px solid #eaf1ff;
      color: #286df7;
    }
  }
  .pie {
    display: flex;
    align-items: center;
    .left,
    .right {
      width: 50%;
      height: 142px;
      margin-top: 10px;
      li {
        p {
          font-weight: 400;
          font-size: 12px;
          color: #555;
        }
      }
    }
    .left {
    }
    .right {
      line-height: 24px;
      li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        p {
          display: flex;
          align-items: center;
          .dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            margin-right: 3px;
          }
        }
      }
    }
  }
  .lsmx {
    margin-top: 20px;
    line-height: 20px;
    .fc-title-sticky {
      ::v-deep {
        .van-sticky--fixed {
          left: 15px;
          right: 15px;
        }
      }
    }
    .title,
    .content-list {
      display: flex;
      align-items: center;
      background: #fff;
      li {
        width: 25%;
        font-weight: 400;
        font-size: 12px;
        color: #999;
        margin-bottom: 8px;
        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(4) {
          text-align: right;
        }
        .StockName {
          font-weight: 600;
          font-size: 14px;
          color: #555;
        }
        .StockCode {
          font-weight: 400;
          font-size: 12px;
          color: #999;
        }
      }
    }
  }
  .all {
    height: 33px;
    background: rgba(40, 109, 247, 0.06) !important;
    border-radius: 4px;
    font-weight: 400;
    font-size: 12px;
    color: #286df7;
    width: 100%;
    border: none !important;
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .title {
    span {
      color: #e4e9fe;
    }
  }
  .lsmx-day {
    .tab {
      background: #191a24;
      li {
        border: 1px solid #46484f;
        background: #191a24;
        color: #e4e9fe;
      }
      .checkedClass {
        border: 1px solid #1f2f4f;
        background: #1f2f4f;
      }
    }
  }
  .pie {
    .right {
      li {
        p {
          color: #e4e9fe;
        }
      }
    }
  }
  .lsmx {
    .fc-title-sticky {
      .title {
        background: #191a24;
        li {
          color: #6b7687;
        }
      }
    }
    .content-list {
      background: #191a24;
      li,
      .StockName {
        color: #e4e9fe !important;
      }
      .StockCode {
        color: #6b7687 !important;
      }
    }
  }
}
</style>
